import {
  AssignModel,
  createClient,
  IdPathParameters,
  OwnerResponse,
  postRequestFactory,
  SaveOperation,
  SearchOperation,
  searchRequestFactory
} from '@infuse/api/common';

const client = createClient('/rest/tariffs');

export const tariffAccessManagementPermissions = {
  ASSIGN: 'cpms.assign-tariff',
  UNASSIGN: 'cpms.unassign-tariff',
  SEARCH_OWNERS: 'cpms.search-tariff-owners'
};

export type AssignTariffRequest = AssignModel;
export type UnassignTariffRequest = AssignModel;

export const assignTariff: SaveOperation<AssignTariffRequest, void, string> = postRequestFactory<
  AssignTariffRequest,
  void
>(client, {
  pattern: '/{id}/assign',
  permissionId: tariffAccessManagementPermissions.ASSIGN
});

export const unassignTariff: SaveOperation<UnassignTariffRequest, void, string> = postRequestFactory<
  UnassignTariffRequest,
  void
>(client, {
  pattern: '/{id}/unassign',
  permissionId: tariffAccessManagementPermissions.UNASSIGN
});

export const getTariffOwners: SearchOperation<OwnerResponse, IdPathParameters<string>> = searchRequestFactory<
  OwnerResponse,
  IdPathParameters<string>
>(client, {
  pattern: '/{id}/owners',
  permissionId: tariffAccessManagementPermissions.SEARCH_OWNERS
});
